import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useDialogHooks from "../../../../../../Components/Dialog/dialog-hooks";
import { ICompanyResponse } from "../../../../../../Interfaces/responseTypes";
import { ICartItem } from "../../../../../../Interfaces/componentTypes";
import { CURRENCY_SYMBOLS } from "../../../../../../Costants/costants";
import MrByteMenu from "./Menu/menu";
import { VisitorPageContents } from "../../../visitorPage";
import MrByteProfile from "./Profile/profile";
import MainCartDialog from "../Components/Dialogs/MainCartDialog/mainCartDialog";
import Language from "../Components/Dialogs/Language/language";
import Footer from "../Components/Footer/footer";
import MyOrders from "./MyOrders/myOrders";
import TableReserveDialog from "../Components/Dialogs/TableReserveDialog/tableReserveDialog";
import { ITableReserveForm } from "../../../../../../Interfaces/formValue-interfaces";

export enum ByteMenuContentTypes {
    CATEGORIES = 'categories',
    ITEMS = 'items'
};

const useByteHooks = (data: ICompanyResponse, type?: VisitorPageContents) => {
    const { services } = data;
    const { i18n } = useTranslation();
    const [mainCart, setMainCart] = useState<ICartItem[] | []>([]);
    const [contentType, setContentType] = useState<VisitorPageContents>(type ?? VisitorPageContents.MENU)
    const { open, onOpen, onClose } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode | null>(null);
    const [isReserveForm, setIsReserveForm] = useState<ITableReserveForm | null>(null)
    const currencySymbol = data.cost_currency ? CURRENCY_SYMBOLS[data.cost_currency] : CURRENCY_SYMBOLS.amd;
    const deliveryMinCost = data.services?.delivery.min_cost;
    const user_id = localStorage.getItem('user_id')

    const onCloseDialog = () => {
        setDialogComponent(null);
        onClose();
    };
    const onSelectLanguage = (active: string) => {
        i18n.changeLanguage(active);
        localStorage.setItem('p_m_language', active);
        onCloseDialog()
    };

    useEffect(() => {
        type && setContentType(type);

    }, [type]);

    useEffect(() => {
        const activeLanguage = localStorage.getItem(`p_m_language`);
        if (!activeLanguage) {
            setDialogComponent(
                <Language
                    logo={data.logo}
                    onSelect={onSelectLanguage}
                />
            )
            onOpen()
        }
    }, []);

    const onOpenReserveDialog = () => {
        onOpen();
        setDialogComponent(
            <TableReserveDialog
                companyId={data.id}
                company_name={data.name}
                company_logo={data.logo}
                company_contacts={data.contacts?.phone_numbers}
                cart={mainCart}
                currencySymbol={currencySymbol}
                onCloseDialog={onClose}
                setContentType={setContentType}
                start_time={data.business_profile?.start_time}
                end_time={data.business_profile?.end_time}
                serviceFee={Number(data.service_fee)}
                setDialog={setDialogComponent}
                setMainCart={setMainCart}
                setIsReserveForm={setIsReserveForm}
                isReserveForm={isReserveForm}
            />
        )
    };

    const renderPage = (type: VisitorPageContents): ReactNode => {
        switch (type) {
            case VisitorPageContents.MENU:
                return (
                    <MrByteMenu
                        data={data!}
                        mainCart={mainCart}
                        currencySymbol={currencySymbol}
                        setMainCart={setMainCart}
                        setContentType={setContentType}
                        onOpenMainCartDialog={onOpenMainCartDialog}
                        is_user={!!user_id}
                        isReserveForm={isReserveForm}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                );
            case VisitorPageContents.PROFILE:
                return (
                    <MrByteProfile
                        data={data!}
                        setContentType={setContentType}
                        is_user={!!user_id}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                );
            case VisitorPageContents.MY_ORDERS:
                return (
                    <MyOrders
                        company_id={data.id}
                        is_user={!!user_id}
                        logo={data.logo}
                        setContentType={setContentType}
                        services={services}
                        business_profile={data.business_profile}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                )
            default:
                return (
                    <MrByteMenu
                        data={data!}
                        mainCart={mainCart}
                        currencySymbol={currencySymbol}
                        setMainCart={setMainCart}
                        setContentType={setContentType}
                        onOpenMainCartDialog={onOpenMainCartDialog}
                        is_user={!!user_id}
                        isReserveForm={isReserveForm}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                )
        }
    };

    const renderFooter = () => {
        return (
            <Footer
                data={data}
                contentType={contentType}
                mainCart={mainCart}
                is_user={!!user_id}
                isReserveForm={isReserveForm}
                setContentType={setContentType}
                onOpenMainCartDialog={onOpenMainCartDialog}
                onOpenReserveDialog={onOpenReserveDialog }
            />
        )
    };


    const onOpenMainCartDialog = () => {
        onOpen();
        setDialogComponent(
            <MainCartDialog
                companyId={data.id}
                company_name={data.name}
                company_logo={data.logo}
                company_contacts={data.contacts?.phone_numbers}
                cart={mainCart}
                setMainCart={setMainCart}
                currencySymbol={currencySymbol}
                serviceFee={Number(data.service_fee)}
                services={data.services}
                setDialog={setDialogComponent}
                onCloseDialog={onClose}
                deliveryMinCost={deliveryMinCost}
                setContentType={setContentType}
                start_time={data.business_profile?.start_time}
                end_time={data.business_profile?.end_time}
            />
        );
    };

    return {
        open,
        contentType,
        mainCart,
        dialogComponent,
        renderPage,
        renderFooter,
        onCloseDialog,
        setContentType,
        onOpenMainCartDialog,
    };
};

export default useByteHooks;
